import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { chakra } from '@chakra-ui/react';
import { cx } from '@chakra-ui/utils';
import * as React from 'react';
var _excluded = ["children", "className"];
var ButtonIcon = function ButtonIcon(props) {
  var children = props.children,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded);
  var _children = /*#__PURE__*/React.isValidElement(children) ? /*#__PURE__*/React.cloneElement(children, {
    'aria-hidden': true,
    focusable: false
  }) : children;
  var _className = cx('chakra-button__icon', className);
  return /*#__PURE__*/React.createElement(chakra.span, _extends({
    display: "inline-flex",
    alignSelf: "center",
    flexShrink: 0
  }, rest, {
    className: _className
  }), _children);
};
ButtonIcon.displayName = 'ButtonIcon';
export { ButtonIcon };